<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <dealHeader :deal="deal" :deal_contact="deal_contact" :stages="stages" :company_users="company_users" :deal_activities="deal_activities"></dealHeader>
        <div class="row">
          <div class="col-md-12">
            <FinanceBox></FinanceBox>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start -->
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import dealHeader from '../Deals/DealHeader'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import FinanceBox from '../Finances/FinanceBox'

export default {
  name: 'deal_finance',
  data() {
    return {
      deal: '',
      deal_contact: [],
      deal_activities: [],
      stages: [],
      company_users: [],
      auth_token: {},
      user_id: '',

    }
  },
  components: {
    Simplert,
    dealHeader,
    FinanceBox,
  },
  created() {
    this.getDeal(this.$route.params.deal_token)
  },
  props: ['toggle_aside'],
  methods: {
    getDeal(deal_token) {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('deals/show', {
          params: {
            'deal': { 'deal_token': deal_token },
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.user_id = response['data']['data']['user_id']
            vm.deal = response['data']['data']['deal']
            vm.deal_contact = vm.deal.deal_contact
            vm.deal_activities = response['data']['data']['deal_activities']
            vm.stages = response['data']['data']['stages']
            vm.company_users = response['data']['data']['company_users']
            vm.quotations = response['data']['data']['quotations']
            vm.activity_categories = response['data']['data']['activity_categories']
          } else {
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    
  },
  filters: {
    moment: function(date) {
      moment.locale('zh-tw');
      return moment(date).format('LLL');;
    },
  }
}
</script>


// WEBPACK FOOTER //
// DealFinance.vue?6d6bde00